import React, { useCallback, useState } from "react";
import { Form, Table } from "react-bootstrap";
import DataTable from "react-data-table-component";
import NumberFormat from "react-number-format";
import CNPJ from "../../Formatters/CNPJ";
import IE from "../../Formatters/IE";
import CPF from "../../Formatters/CPF";
import { formatarData } from "../../Formatters/DateTime";
import constants from "../../../pages/Constants";

const autoDeInfracaoCell = (row) => {
  if (row.produtosAcaoFiscal.length > 0) {
    return (
      <Table width="99%">
        <thead>
          <tr>
            <th width="40%">Número</th>
            <th width="30%">ICMS</th>
            <th width="30%">Multa</th>
          </tr>
        </thead>
        <tbody>
          {row.produtosAcaoFiscal.map((item) => (
            <tr>
              <td>{item.numeroProdutoAcaoFiscal}</td>
              <td>
                <NumberFormat
                  value={item.icms}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowNegative={false}
                  decimalScale={2}
                  fixedDecimalScale
                />
              </td>
              <td>
                <NumberFormat
                  value={item.multa}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowNegative={false}
                  decimalScale={2}
                  fixedDecimalScale
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }

  return null;
};

const periodoDeFiscalizacaoCell = (row) => {
  let periodo = " - ";

  if (formatarData(row.dataInicialFiscalizacao) !== "01/01/0001") {
    periodo = `${formatarData(row.dataInicialFiscalizacao)} - ${formatarData(row.dataFinalFiscalizacao)}`;
  }

  return <div>{periodo}</div>;
};

const columns = [
  {
    name: "IE",
    // selector: 'ie',
    cell: (row) => <IE value={row.ie} />,
    width: "15%",
  },
  {
    name: "CNPJ/CPF",
    // selector: 'cpfCnpj',
    cell: (row) => (row.cpfCnpj.length === 11 ? <CPF value={row.cpfCnpj} /> : <CNPJ value={row.cpfCnpj} />),
    width: "19%",
  },
  {
    name: "Razão Social",
    selector: (row) => row.nome,
    width: "38%",
  },
  {
    name: "Qtd Ações",
    cell: (row) => row.acoesFiscais.length,
    width: "10%",
  },
  {
    name: "Qtd Cobrança",
    selector: (row) => row.qtdCobranca,
    width: "10%",
  },
];

const columnsAcoes = [
  {
    name: "N° OS",
    selector: (row) => row.sequencialOrdemServico,
    width: "5%",
  },

  {
    name: "Período da OS",
    cell: (row) => (
      <div>
        {formatarData(row.dataInicial) !== "01/01/0001"
          ? `${formatarData(row.dataInicial)} - ${formatarData(row.dataFinal)}`
          : " - "}
      </div>
    ),
    width: "12%",
  },
  {
    name: "Tipo da Ação",
    selector: (row) => row.descricaoTipoAcaoFiscal,
    width: "14%",
  },
  {
    name: "Procedimentos",
    cell: (row) => (
      <div>
        {row.procedimentos.map((item) => (
          <li>{item.nome}</li>
        ))}
      </div>
    ),
    width: "20%",
  },

  {
    name: "Período de Fiscalização",
    cell: (row) => periodoDeFiscalizacaoCell(row),
    width: "13%",
  },
  {
    name: "Executores",
    cell: (row) => (
      <div>
        {row.executores.map((item) => (
          <li>{item.nomeExecutor}</li>
        ))}
      </div>
    ),
    width: "18%",
  },

  {
    name: "Auto de Infração",
    cell: (row) => autoDeInfracaoCell(row),
    width: "17%",
  },
];

const ExpandableComponentAcoes = ({ row }) => (
  <div>
    <DataTable
      noHeader
      columns={columnsAcoes}
      data={row.data.acoesFiscais}
      noDataComponent="Nenhum registro para exibir"
    />
  </div>
);

const TableContribuinteSpf = ({ formik, field, data }) => {
  const setPageSize = useState(25)[1];
  const setPageNumber = useState(1)[1];

  const handlePageChange = useCallback(
    (newPageNumber) => {
      setPageNumber(newPageNumber);
    },
    [setPageNumber],
  );

  const handlePerRowsChange = useCallback(
    (newPageSize) => {
      setPageSize(newPageSize);
      setPageNumber(1);
    },
    [setPageSize, setPageNumber],
  );

  return (
    <>
      <Form.Label className="small">
        {`Total de registros: ${data ? data.length : 0}`}
        <br />
        {`Total selecionado: ${formik.values[field] ? formik.values[field].length : 0}`}
      </Form.Label>
      <br />
      <Form.Label className="text-danger small">{formik.errors[field] ? formik.errors[field] : ""}</Form.Label>
      <DataTable
        title="Lista de Contribuintes"
        fixedHeader
        noHeader
        columns={columns}
        data={data}
        noDataComponent="Nenhum registro para exibir"
        selectableRows
        onSelectedRowsChange={(item) => formik.setFieldValue(field, item.selectedRows)}
        expandableRows
        expandableRowsComponent={(row) => ExpandableComponentAcoes({ row })}
        paginationComponentOptions={constants.paginationComponentOptions}
        paginationPerPage={25}
        pagination
        sortable
        paginationTotalRows={data.length}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
      />
    </>
  );
};

export default TableContribuinteSpf;
